module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic-ext22.251d36f.woff2";